import { useQuery, UseQueryResult } from 'react-query';
import { EventAthleteHasValidCreditDispensation } from 'types';
import { client } from 'utils/api-client';

function useEventAthleteHasValidCreditDispensation({
  eventId,
  eventType,
  athleteId,
  enabled = true,
}: {
  eventId: string | undefined;
  eventType: 'kilo_class' | 'appointment';
  athleteId: string | undefined;
  enabled?: boolean;
}): UseQueryResult<{ data: EventAthleteHasValidCreditDispensation }> {
  return useQuery(
    ['events', 'check-athlete-has-valid-credit-dispensation', eventId, eventType, athleteId],
    () =>
      client.get(`events/${eventId}/athlete-has-valid-credit-dispensation/`, {
        params: {
          event_type: eventType,
          athlete_id: athleteId,
        },
      }),
    {
      enabled: enabled && !!eventId && !!eventType && !!athleteId,
    },
  );
}

export default useEventAthleteHasValidCreditDispensation;
